import React, { useState } from 'react';
import style from './listaBalneario.module.scss';
import {
  IBalnearioComBanhoLista,
  IBalnearioSemBanhoLista,
} from '../../../../../../../../../../../interfaces/IBalneario';
import { PaginasOutrosRegimes } from '../../../../../../../../../../../interfaces/IDadosOutrosRegimes';
import ListaBalnearioItem from './components/listaBalnearioItem/listaBalnearioItem';

interface IListaBalneariosProps {
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  itensComBanho?: IBalnearioComBanhoLista[];
  itensSemBanho?: IBalnearioSemBanhoLista[];
  refetchLista: () => void;
  refetchDados: () => void;
}

const ListaBalneario = ({
  setBaseDeCalculo,
  setIsEdicao,
  itensComBanho,
  itensSemBanho,
  refetchLista,
  refetchDados,
}: IListaBalneariosProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  let contador = 0;

  return (
    <>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title}>Balneário</div>
        </div>
        <div className={style.rightContainer}></div>
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          {itensComBanho?.map((item) => {
            contador++;
            return (
              <ListaBalnearioItem
                comBanho={true}
                itemComBanho={item}
                index={contador}
                key={item.id}
                setBaseDeCalculo={setBaseDeCalculo}
                setIsEdicao={setIsEdicao}
                refetchLista={refetchLista}
                refetchDados={refetchDados}
              />
            );
          })}
          {itensSemBanho?.map((item) => {
            contador++;
            return (
              <ListaBalnearioItem
                comBanho={false}
                itemSemBanho={item}
                index={contador}
                key={item.id}
                setBaseDeCalculo={setBaseDeCalculo}
                setIsEdicao={setIsEdicao}
                refetchLista={refetchLista}
                refetchDados={refetchDados}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default ListaBalneario;
